const DB_NAME  = 'ondoku_audio_db';
const DB_VER   = 1;
const STORE    = 'blobs';

// 保存済み音声IDの管理（localStorage）
const AUDIO_IDS_KEY = 'saved_audio_ids';

// ローカル保存は無料・プレミアム共に無制限（端末内）
// クラウド保存の上限は audioStorageApi.js の CLOUD_AUDIO_LIMIT で管理
export const FREE_AUDIO_LIMIT    = Infinity;
export const PREMIUM_AUDIO_LIMIT = Infinity;

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VER);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE);
      }
    };
    req.onsuccess = (e) => resolve(e.target.result);
    req.onerror   = ()  => reject(new Error('IndexedDB open failed'));
  });
}

/** 保存済み音声IDリストを取得（古い順） */
function getSavedIds() {
  try {
    return JSON.parse(localStorage.getItem(AUDIO_IDS_KEY) || '[]');
  } catch { return []; }
}

/** 保存済み音声IDリストを更新 */
function setSavedIds(ids) {
  localStorage.setItem(AUDIO_IDS_KEY, JSON.stringify(ids));
}

/** 現在の保存件数 */
export function getAudioCount() {
  return getSavedIds().length;
}

/** 音声blob を recordId で保存（件数制限あり） */
export async function saveAudio(recordId, blob, isPremium = false) {
  try {
    const limit = isPremium ? PREMIUM_AUDIO_LIMIT : FREE_AUDIO_LIMIT;
    const db = await openDB();

    // 保存
    await new Promise((res, rej) => {
      const tx = db.transaction(STORE, 'readwrite');
      tx.objectStore(STORE).put(blob, recordId);
      tx.oncomplete = res;
      tx.onerror    = rej;
    });

    // IDリストに追加
    const ids = getSavedIds().filter(id => id !== recordId); // 重複除去
    ids.push(recordId);

    // 上限を超えた古いものを削除
    while (ids.length > limit) {
      const oldId = ids.shift();
      await deleteAudio(oldId, false); // IDリスト更新なしで削除
    }

    setSavedIds(ids);
  } catch (e) {
    console.warn('音声保存エラー:', e);
  }
}

/** recordId に対応する blob を取得 */
export async function loadAudio(recordId) {
  try {
    const db = await openDB();
    return await new Promise((res, rej) => {
      const tx  = db.transaction(STORE, 'readonly');
      const req = tx.objectStore(STORE).get(recordId);
      req.onsuccess = (e) => res(e.target.result ?? null);
      req.onerror   = rej;
    });
  } catch (e) {
    console.warn('音声読み込みエラー:', e);
    return null;
  }
}

/** 音声を削除 */
export async function deleteAudio(recordId, updateList = true) {
  try {
    const db = await openDB();
    await new Promise((res, rej) => {
      const tx = db.transaction(STORE, 'readwrite');
      tx.objectStore(STORE).delete(recordId);
      tx.oncomplete = res;
      tx.onerror    = rej;
    });
    if (updateList) {
      setSavedIds(getSavedIds().filter(id => id !== recordId));
    }
  } catch (e) {
    console.warn('音声削除エラー:', e);
  }
}

/** この録音IDの音声が保存されているか */
export function isAudioSaved(recordId) {
  return getSavedIds().includes(recordId);
}
